import { lazy, Suspense } from "react";
import { LoaderCircle } from "lucide-react";
import { useStudioLocale } from "@/i18n/use-studio-locale";
import type { OpenPencilFigmaSourceBundle } from "./openpencil-figma-source";
import { OPENPENCIL_PRIMARY_SOURCE_COPY } from "./openpencil-primary-source-copy";

const OpenPencilBrowserCanvas = lazy(() =>
  import("./openpencil-browser-canvas").then((module) => ({
    default: module.OpenPencilBrowserCanvas,
  })),
);

interface Props {
  bundle: OpenPencilFigmaSourceBundle;
  selectedSurfaceId?: string;
  onSelectedSurfaceIdChange?: (surfaceId: string) => void;
  onActivePageIdChange?: (pageId: string) => void;
}

export function OpenPencilBrowserCanvasLoading() {
  const { locale } = useStudioLocale();
  const copy = OPENPENCIL_PRIMARY_SOURCE_COPY[locale].editor;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="openpencil-browser-canvas-loading"
      className="flex min-h-80 items-center justify-center gap-2 rounded-md border border-border bg-muted/20 px-4 text-sm text-muted-foreground"
    >
      <LoaderCircle className="h-4 w-4 animate-spin" aria-hidden />
      <span>{copy.opening}</span>
    </div>
  );
}

export function OpenPencilBrowserCanvasLazy({
  bundle,
  selectedSurfaceId,
  onSelectedSurfaceIdChange,
  onActivePageIdChange,
}: Props) {
  return (
    <Suspense fallback={<OpenPencilBrowserCanvasLoading />}>
      <OpenPencilBrowserCanvas
        bundle={bundle}
        selectedSurfaceId={selectedSurfaceId}
        onSelectedSurfaceIdChange={onSelectedSurfaceIdChange}
        onActivePageIdChange={onActivePageIdChange}
      />
    </Suspense>
  );
}
